export const navigationV2 = {
  home: () => {
    return "/home";
  },
  dashboard: () => {
    return "/";
  },
  dashboardNotFound: () => {
    return "/not-found";
  },
  login: (searchParams?: URLSearchParams) => {
    return `/login${searchParams ? `?${searchParams.toString()}` : ""}`;
  },
  loginCallback: () => {
    return "/login/callback";
  },
  signUp: (step?: number) => {
    return `/sign-up${step ? `?step=${step}` : ""}`;
  },
  visits: () => {
    return "/visits";
  },
  newVisit: () => {
    return "/visit/new";
  },
  visit: (encounterId: string | number) => {
    return `/visit/${encounterId}`;
  },
  patients: () => {
    return "/patients";
  },
  patientDetail: (patientId: string) => {
    return `/patients/${patientId}`;
  },
  documents: () => {
    return "/documents";
  },
  settings: () => {
    return "/settings";
  },
  settingsAccount: () => {
    return "/settings/account";
  },
  settingsPreferences: () => {
    return "/settings/preferences";
  },
  settingsPracticeInfo: () => {
    return "/settings/practice-info";
  },
  settingsSecurity: () => {
    return "/settings/security";
  },
};
